import { render, staticRenderFns } from "./PreferenceOptionsForm.vue?vue&type=template&id=0b649d8d&"
import script from "./PreferenceOptionsForm.vue?vue&type=script&lang=ts&"
export * from "./PreferenceOptionsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports